
export const HOT_TREND_INDEX_REQUEST = 'HOT_TREND_INDEX_REQUEST';
export const HOT_TREND_INDEX_SUCCESS = 'HOT_TREND_INDEX_SUCCESS';
export const HOT_TREND_INDEX_ERROR = 'HOT_TREND_INDEX_ERROR';

export const HOT_TREND_DETAIL_REQUEST = 'HOT_TREND_DETAIL_REQUEST';
export const HOT_TREND_DETAIL_SUCCESS = 'HOT_TREND_DETAIL_SUCCESS';
export const HOT_TREND_DETAIL_ERROR = 'HOT_TREND_DETAIL_ERROR';
